<template>
  <div id="app">
    <headerNav />
    <router-view/>
    <footerbox/>
  </div>
</template>

<script>
  import headerNav from '@/components/headerNav.vue'
  import footerbox from '@/components/footerPage.vue'
  import './assets/css/style.css'
  export default {
    components: {
      headerNav,
      footerbox
    }
  }
</script>


<style>
/* body{background: url(assets/images/bgimg.jpg)  no-repeat;background-attachment:fixed;background-position-y: 39%;background-size:100%} */
</style>
